import Cookies from 'js-cookie';

(($) => {
  $(() => {
    const $section = $('.section--registration-form');

    if ($section.length) {
      const $form = $section.find('form#create_customer');
      const $alert = $form.find('.alert');
      const $acceptsMarketing = $form.find('input[name="customer[accepts_marketing]"]');
      const cookieName = 'registered';
      const cookieValue = Cookies.get(cookieName);

      if ($alert.length && 'failed' === cookieValue) {
        $alert.show();
        Cookies.remove(cookieName);
      }

      $form.on('submit', (e) => {
        if ('undefined' === typeof cookieValue) {
          Cookies.set(cookieName, 'failed');
        }

        /**
         * Some data about this form's submission is stored in localStorage
         * (registrationFormResult) so that it can be used later in the
         * registration process. Refer to form.online-registration.liquid
         * for additional information.
         */
        const registrationFormResultObject = {
          'marketing_opt_in_status': $acceptsMarketing.length && $acceptsMarketing.is(':checked'),
        };

        localStorage.setItem('registrationFormResult', JSON.stringify(registrationFormResultObject));
      });
    }
  });
})(jQuery);
